<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>日语资源转化率</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="80px"
        size="small"
        class="query-form"
        label="录入时间"
      >
        <el-form-item label="录入时间">
          <el-date-picker
            v-model="query.time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getList();"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="缴费时间">
          <el-date-picker
            v-model="query.timeone"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getList();"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList();">查询</el-button>
        </el-form-item>
      </el-form>

      <div style="height:20px;"></div>
      <el-card class="box-card collectCard" shadow="always" v-if="marketList.length>0 || adviserList.length>0">
        <div class="clearfix" slot="header">
          <span>总计转化率</span>
        </div>
        <div class="index-card" style="height:auto;">
          <el-col :span="4" class="stateItem">
            <div class="state">资源总数</div>
            <div class="person">
              <span style="color:#D82C34;font-size:14px;">{{total.totalCount}}人</span>
            </div>
          </el-col>
          <el-col :span="4" class="stateItem">
            <div class="state">新报人数</div>
            <div class="person">
              <span style="color:#D82C34;font-size:14px;">{{total.signCount}}人</span>
            </div>
          </el-col>
          <el-col :span="4" class="stateItem">
            <div class="state">新报金额</div>
            <div class="person">
              <span style="color:#D82C34;font-size:14px;">{{formatMoney(total.newSignAmount)}}</span>
            </div>
          </el-col>
          <el-col :span="4" class="stateItem">
            <div class="state">转化率</div>
            <div class="person">
              <span style="color:#67c23a;font-size:14px;">{{total.persentShow}}</span>
            </div>
          </el-col>
          <el-col :span="4" class="stateItem">
            <div class="state">续课人数</div>
            <div class="person">
              <span style="color:#409EFF;font-size:14px;">{{total.renewPersonCount || 0}}人</span>
            </div>
          </el-col>
          <el-col v-if="showRenewAmount" :span="4" class="stateItem">
            <div class="state">续课金额</div>
            <div class="person">
              <span style="color:#409EFF;font-size:14px;">{{formatMoney(total.renewAmount)}}</span>
            </div>
          </el-col>
          <el-col :span="4" class="stateItem">
            <div class="state">续课率</div>
            <div class="person">
              <span style="color:#409EFF;font-size:14px;">{{total.renewRateShow}}</span>
            </div>
          </el-col>
        </div>
      </el-card>
      <div style="height:20px;"></div>
      <el-card class="box-card collectCard" shadow="always" v-if="marketList.length>0">
        <div class="clearfix" slot="header">
          <span>营销团队转化率统计</span>
        </div>
        <div class="index-card" style="height:auto;">
          <el-table
            v-loading="loading"
            :data="marketList"
            border
            stripe
            style="width:100%;"
            show-summary
            :summary-method="japSummaryMethod"
          >
            <el-table-column prop="name" label="员工"></el-table-column>
            <el-table-column prop="totalCount" label="资源总数" sortable></el-table-column>
            <el-table-column prop="signCount" label="新报人数" sortable></el-table-column>
            <el-table-column prop="newSignAmount" label="新报金额" sortable>
              <template slot-scope="scope">{{ formatMoney(scope.row.newSignAmount) }}</template>
            </el-table-column>
            <el-table-column prop="persentShow" label="转化率" sortable></el-table-column>
            <el-table-column prop="renewPersonCount" label="续课人数" sortable></el-table-column>
            <el-table-column v-if="showRenewAmount" prop="renewAmount" label="续课金额" sortable>
              <template slot-scope="scope">{{ formatMoney(scope.row.renewAmount) }}</template>
            </el-table-column>
            <el-table-column prop="renewRateShow" label="续课率" sortable></el-table-column>
            <el-table-column label="转化进度" width="300">
              <template slot-scope="scope">
                <el-progress
                  :text-inside="true"
                  :stroke-width="24"
                  :percentage="scope.row.persent"
                  status="success"
                ></el-progress>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <div style="height:20px;"></div>
      <el-card class="box-card collectCard" shadow="always" v-if="adviserList.length>0">
        <div class="clearfix" slot="header">
          <span>顾问团队转化率统计</span>
        </div>
        <div class="index-card" style="height:auto;">
          <el-table
            v-loading="loading"
            :data="adviserList"
            border
            stripe
            style="width:100%;"
            show-summary
            :summary-method="japSummaryMethod"
          >
            <el-table-column prop="name" label="员工"></el-table-column>
            <el-table-column prop="totalCount" label="资源总数" sortable></el-table-column>
            <el-table-column prop="signCount" label="新报人数" sortable></el-table-column>
            <el-table-column prop="newSignAmount" label="新报金额" sortable>
              <template slot-scope="scope">{{ formatMoney(scope.row.newSignAmount) }}</template>
            </el-table-column>
            <el-table-column prop="persentShow" label="转化率" sortable></el-table-column>
            <el-table-column prop="renewPersonCount" label="续课人数" sortable></el-table-column>
            <el-table-column v-if="showRenewAmount" prop="renewAmount" label="续课金额" sortable>
              <template slot-scope="scope">{{ formatMoney(scope.row.renewAmount) }}</template>
            </el-table-column>
            <el-table-column prop="renewRateShow" label="续课率" sortable></el-table-column>
            <el-table-column label="转化进度" width="300">
              <template slot-scope="scope">
                <el-progress
                  :text-inside="true"
                  :stroke-width="24"
                  :percentage="scope.row.persent"
                  status="success"
                ></el-progress>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: { time: [], timeone: [] },
      loading: false,
      total: {},
      marketList: [],
      adviserList: [],
      showRenewAmount: false
    };
  },
  methods: {
    formatMoney(val) {
      var n = Number(val || 0);
      return n.toLocaleString("zh-CN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    /** 列表底部汇总行：数量/金额求和，转化率按合计重算 */
    japSummaryMethod({ columns, data }) {
      var sums = [];
      var totalCount = 0;
      var signCount = 0;
      var newSignAmount = 0;
      var renewPersonCount = 0;
      var renewAmount = 0;
      (data || []).forEach(function (row) {
        totalCount += Number(row.totalCount || 0);
        signCount += Number(row.signCount || 0);
        newSignAmount += Number(row.newSignAmount || 0);
        renewPersonCount += Number(row.renewPersonCount || 0);
        renewAmount += Number(row.renewAmount || 0);
      });
      var persent = totalCount === 0 ? 0 : Math.round((signCount * 1000) / totalCount) / 10;
      var renewRate = signCount === 0 ? 0 : Math.round((renewPersonCount * 1000) / signCount) / 10;
      var _this = this;
      columns.forEach(function (col, index) {
        if (index === 0) {
          sums[index] = "汇总";
          return;
        }
        if (col.property === "totalCount") sums[index] = totalCount;
        else if (col.property === "signCount") sums[index] = signCount;
        else if (col.property === "newSignAmount") sums[index] = _this.formatMoney(newSignAmount);
        else if (col.property === "persentShow") sums[index] = persent + "%";
        else if (col.property === "renewPersonCount") sums[index] = renewPersonCount;
        else if (col.property === "renewAmount") sums[index] = _this.formatMoney(renewAmount);
        else if (col.property === "renewRateShow") sums[index] = renewRate + "%";
        else sums[index] = "";
      });
      return sums;
    },
    getList: function () {
      var _this = this;
      var params = Object.assign({}, _this.query);
      var hasTime = params.time && params.time.length === 2;
      var hasTimeone = params.timeone && params.timeone.length === 2;
      if (hasTime) {
        params.start = typeof params.time[0] === "string" ? params.time[0] : params.time[0].format("yyyy-MM-dd");
        params.end = typeof params.time[1] === "string" ? params.time[1] : params.time[1].format("yyyy-MM-dd");
      } else {
        delete params.start;
        delete params.end;
      }
      if (hasTimeone) {
        params.startone = typeof params.timeone[0] === "string" ? params.timeone[0] : params.timeone[0].format("yyyy-MM-dd");
        params.endone = typeof params.timeone[1] === "string" ? params.timeone[1] : params.timeone[1].format("yyyy-MM-dd");
      } else {
        delete params.startone;
        delete params.endone;
      }
      delete params.time;
      delete params.timeone;
      _this.loading = true;
      var link = url.getCollect("GetConvertJap");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.adviserList = data.adviserList || [];
        _this.marketList = data.marketList || [];
        _this.total = data.total || {};
        _this.showRenewAmount = !!(data.showRenewAmount || user.isJapEdu() || user.isAdmin());
      });
    }
  },
  mounted() {
    var now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), 1);
    var fmt = function (d) {
      var y = d.getFullYear(),
        m = d.getMonth() + 1,
        day = d.getDate();
      return y + "-" + (m < 10 ? "0" : "") + m + "-" + (day < 10 ? "0" : "") + day;
    };
    this.query.time = [fmt(start), fmt(now)];
    this.query.timeone = [fmt(start), fmt(now)];
    this.getList();
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
.stateItem {
  text-align: center;
  line-height: 3em;
  padding-top: 1em;
}
.stateItem .state {
  font-size: 16px;
  line-height: 30px;
}
.stateItem .person {
  letter-spacing: 2px;
  color: #aaa;
}
</style>
